import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConnectService } from '../../../service/auth-connect.service';
import { SignupService } from '../../../service/signup.service';
import { p_forgot_pass } from '../../../auth-constants';
import { getCachedTenantData } from '@laasy/common-layout';

@Component({
  selector: 'app-auth-connect-header',
  templateUrl: './auth-connect-header.component.html',
  styleUrls: ['./auth-connect-header.component.scss']
})
export class AuthConnectHeaderComponent implements OnInit{

  @Input() isBackButton = false
  pageConfig:any

  constructor(private readonly router: Router, private authConnect:AuthConnectService, private signupService:SignupService){}

  ngOnInit(): void {
    this.authConnect.getPageData().subscribe((data:any)=>{
      const tenantData = getCachedTenantData();
      data.subheading1 = data.subheading1?.replace('${tenant}',tenantData?.name)
      this.pageConfig = data
    })
  }
  navigate(page: string) {
    this.signupService.setSignUpPageCount(0)
    const path = page.replace(/\s+/g, '');
    this.router.navigate(['auth', path.toLowerCase()]);
  }

  getColor() {
    if (this.pageConfig.heading == p_forgot_pass.heading) return { color: 'var(--grey-600, #6F6F6F)' };
    return {};
  }
}
